angular.module('myApp.services')
    .factory("audioVideoResponseWindowMobile", function() {
        var audioVideoOptions = {};
        return {
            setAVOptions : function (options) {
                if (typeof options == 'object') {
                    audioVideoOptions = options;
                }
            },
            getAVOptions : function () {
                return audioVideoOptions;
            }
        }
    });